<template>
    <div v-if="active" class="card">        
        <a class="theme-primary help-icon icon text-right" href="login-help.html" target="_blank" alt="Login Help">
            <fa-icon :icon="['fas','question-circle']" /><span class="sr-only">login help</span>
        </a>
        <div class="card-body">
            <PageHeader :title="title" variant="small" class="mb-4" />
            <p>{{screenData.text.accountLocked}}</p>
            <p>{{screenData.text.unableToVerify}}</p>
            <p>{{screenData.text.genericErrorMessage}} {{screenData.text.contactUs}}</p>
            <ActionList :actions="screenData.actions" @exit-login="exitLogin" />
        </div>
    </div>

</template>

<script>
    import ActionList from '../entities/ActionList.vue';
    import PageHeader from '../entities/PageHeader.vue';

    export default {
        name: "AccountHold",

        components: {
            ActionList,
            PageHeader
        },

        props : {
            screenData: Object
        },

        data: function() {
            return {
                active: false,
                flow: "",
                errorCode: "",
                isSuspended: false
            }
        },

        methods: {
            show: function(data) {
                this.flow = data.flow;
                this.errorCode = data.errorCode;
                this.isSuspended = data.isSuspended;
                this.active = true;
            },

            hide: function() {
                this.active = false;
            },

            exitLogin: function() {
                this.$emitter.emit('start-loading','exit-login');
                window.location.href = window.location.href;
            }
        },
        computed: {
            title: function(){
                return this.flow + ": " + this.screenData.text.cardTitle
            }
        }
    }
</script>
